import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { exchangeSession } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");

    if (!sid) {
      navigate("/", { replace: true });
      return;
    }

    (async () => {
      try {
        const { user } = await exchangeSession(sid);
        setUser(user);
        // strip hash from URL
        window.history.replaceState({}, document.title, "/dashboard");
        navigate("/dashboard", { replace: true, state: { user } });
      } catch (e) {
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F7F4]">
      <div className="text-center">
        <div className="overline mb-3">Authenticating</div>
        <div className="font-display text-3xl">Signing you in…</div>
      </div>
    </div>
  );
}
